import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "AlertsNotificationBadge",
  props: {
    urgencyCount: {
      type: Number,
      default: 0
    }
  }
};